type Widget={unmount:()=>void};
declare global {interface Window {SumUpCard?:{mount:(options:Record<string,unknown>)=>Widget}}}
let sdk:Promise<void>|undefined;
export function loadSumUpSdk(){
 if(window.SumUpCard)return Promise.resolve();
 if(!sdk)sdk=new Promise<void>((resolve,reject)=>{
  const script=document.createElement('script');script.src='https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js';script.async=true;
  const timeout=setTimeout(()=>{script.remove();sdk=undefined;reject(Error('SDK'));},20000);
  script.onload=()=>{clearTimeout(timeout);if(window.SumUpCard)resolve();else{sdk=undefined;reject(Error('SDK'));}};
  script.onerror=()=>{clearTimeout(timeout);script.remove();sdk=undefined;reject(Error('SDK'));};document.head.append(script);
 });return sdk;
}
